/**
*****************************************
*										*
* NAGARRO  - CSX - CONFIDENTIAL         *
*										*
*****************************************
*/

import { RouterModule, Routes } from '@angular/router';

import { LmsTonnageRatingsComponent } from '../core/component/lms-tonnage/lms-tonnage-ratings/lms-tonnage-ratings.component';
import { NgModule } from '@angular/core';
import { TonnageRatingsResolver } from './shared/tonnage-ratings.resolver';

const tonnageRatingsRoutes: Routes = [
    {
        path: 'tonnage-ratings',
        component: LmsTonnageRatingsComponent,
        data: { tab: 'Tonnage-Ratings' },
        resolve: {
                    tabData: TonnageRatingsResolver
                },
         children: [
                    
                     {
                         path: 'data/:tabid',
                         component: LmsTonnageRatingsComponent,
                         data: { tab: 'Tonnage-Ratings' },
                         resolve: {
                             tabData: TonnageRatingsResolver
                         }
                     }]

    }
];

/**
 * @export
 * @class TonnageRatingsRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forChild(tonnageRatingsRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class TonnageRatingsRoutingModule {

}
